export default "__VITE_ASSET__7e380698__"